import Vue from 'vue';

window.Vue = Vue;

if (window.specialtyApp) {
    window.specialtyApp.eventBus = new Vue();
} else {
    window.specialtyApp = {
        eventBus: new Vue(),
    };
}
